import store from 'store';

export function getCurrentInventoryDropdownFromLocalStorage() {
  return store.get('moka:currentInventoryDropdown');
}

export function setCurrentInventoryDropdownFromLocalStorage(value) {
  return store.set('moka:currentInventoryDropdown', value);
}

export function delCurrentInventoryDropdownFromLocalStorage() {
  return store.remove('moka:currentInventoryDropdown');
}
